export default __webpack_public_path__ + "static/media/b52.6a629e4e.png";